import { searchActions } from 'actions/search';

export const getSearchData = (dispatch, params, isAppend, success) => {
	
	return new Promise((resolve, reject) => {
			dispatch(searchActions.getResults({ ...params, isAppend }, { resolve, reject }));
	})
		.then(() => success())
		.catch(() => success());
};